import $ from 'jquery';

function gallery() {
	var lastScrollTop = 0;
	var headerMain;
	var headerTop;
	var searchMatch;
	var filterVar;
	var searchTerm = '';
	var filters = {};
	var comboFilter;
	
	function renderLightbox(el) {
				var image = $(el).data('image');
				var url = $(el).data('url');
				var id = $(el).data('id');
				var niceName = $(el).data('nice-name');
				var content = $(el).data('content');
				$('#gallery-lightbox').attr('style','background-image:url(\'' + image + '\');display:block;' );
				$('#gallery-lightbox h2').text(niceName);
				$('#gallery-lightbox').attr('data-index', id);
				$('#gallery-lightbox p').text(content);
				$('#gallery-view').attr('href',url);
			}
	function debounce( fn, threshold ) {
	  var timeout;
	  threshold = threshold || 250;
	  return function debounced() {
	    clearTimeout( timeout );
	    var args = arguments;
	    var _this = this;
	    function delayed() {
	      fn.apply( _this, args );
	    }
	    timeout = setTimeout( delayed, threshold );
	  };
	}
	function hideMenu() {
	  var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
	   if (st > lastScrollTop){
	     $(headerMain).addClass('down-scroll');
	     $(headerMain).removeClass('up-scroll');
	     $(headerTop).fadeOut('fast');
	   } else {
	      $(headerMain).addClass('up-scroll');
	      $(headerMain).removeClass('down-scroll');
	      $(headerTop).fadeIn('fast');
	   }
	   lastScrollTop = st <= 0 ? 0 : st;
	}
	function getComboFilter() {
		  var combo = [];
		  for ( var prop in filters ) {
		    var group = filters[ prop ];
		    if ( !group.length ) {
		      continue;
		    }
		    if ( !combo.length ) {
		      combo = group.slice(0);
		      continue;
		    }
		    var nextCombo = [];
		    for ( var i=0; i < combo.length; i++ ) {
		      for ( var j=0; j < group.length; j++ ) {
		        var item = combo[i] + group[j];
		        nextCombo.push( item );
		      }
		    }
		    combo = nextCombo;
		  }
		  var comboFilter = combo.join(', ');
		  return comboFilter;
		}

	$(window).scroll(debounce(function() {
		hideMenu();
	}));
	$( document ).ready(function() {
			var container = $('#gallery-images').isotope({
			  itemSelector: '.element-item'
			});
			var checkboxes = $('#gallery-navigation input:checkbox');
			
			headerMain = $('.c-header_main').first();
			headerTop = $('#c-header_top');

			queryParam();

			function queryParam() {
				var filterGroup = [];
				let queryParams = new URLSearchParams(window.location.search);
					if( queryParams.has('filter') ) {
						let param = '.' + queryParams.get('filter');
						filterGroup.push( param );
					}

					comboFilter = filterGroup[0];
				  //container.isotope({ filter: comboFilter });
				  container.isotope({ filter: function() {
						var checkResult = comboFilter ? $(this).is(comboFilter) : true;
    				return checkResult;
				  }});
			}

			checkboxes.change( function() {
				var checkbox = event.target;
				  var $checkbox = $( checkbox );
				  var group = $checkbox.parents('.panel').attr('data-group');
					var filterGroup = filters[ group ];

				  if ( !filterGroup ) {
				    filterGroup = filters[ group ] = [];
				  }
				  if ( checkbox.checked ) {
				    filterGroup.push( checkbox.value );
				  } else {
				    var index = filterGroup.indexOf( checkbox.value );
				    filterGroup.splice( index, 1 );
					}
				  
					comboFilter = getComboFilter();
				  //container.isotope({ filter: comboFilter });
				  container.isotope({ filter: function() {
				    var checkResult = comboFilter ? $(this).is(comboFilter) : true;
				    var searchResult = searchMatch ? $(this).data('nice-name').match( searchMatch ) : true;
    				return checkResult && searchResult;
				  }});
			});
			$('#gallery-search').keyup(debounce(function(){
			  searchMatch = new RegExp( $(this).val(), 'gi' );  
			  container.isotope({ filter: function() {
				    var searchResult = searchMatch ? $(this).data('nice-name').match( searchMatch ) : true;
				    var checkResult = comboFilter ? $(this).is(comboFilter) : true;
    				return searchResult && checkResult;
				  }});
			},100));


			$('.element-item').click(function(e){
				renderLightbox(this);
				location.hash = $(this).data('name');
			});
			// $('#gallery-lightbox').click(function(){
			// 	$(this).hide();
			// 	history.replaceState(null, null, ' ');
			// });
			$('#gallery-close').click(function(){
				$('#gallery-lightbox').hide();
				history.replaceState(null, null, ' ');
			});
			$(document).keyup(function(e) {
				if( e.key === "Escape" ) {
					$('#gallery-lightbox').hide();
					history.replaceState(null, null, ' ');
				}
			});
		    $('#gallery-navigation h2').click(function(){
		    	$(this).next('div.panel').toggle();
		    	$(this).find('span').toggleClass('minimize');
		    });
		    if(location.hash.length > 1) {
		    	var el = $('.element-item[data-name="'+ location.hash.replace('#','') +'"]');
		    	renderLightbox(el);
		    }
		    $('#clear-button').click(function(){
		    	checkboxes.each( function( i, elem ) {
				  $(elem).prop("checked", false);
			  	});
		    	filters = {};
		    	searchTerm = '';
		    	searchMatch = '';
		    	comboFilter = '';
				container.isotope({ filter:'*' });
				$('#gallery-search').val('');
		    })
		});

		// Prev Next Function
		var $lightbox     = $('.c-gallery_lightbox'),
				$galleryItems = $('.element-item'),
				$prev         = $('.c-gallery_prev'),
				$next         = $('.c-gallery_next');

		$next.click(function() {
			var $currentSlide = $lightbox.attr('data-index');
			
			$galleryItems.each(function() {
				if( $(this).is(':visible') && $(this).attr('data-id') == $currentSlide ) {
					var $nextSlide = $(this).nextAll('div:visible');
					if( $nextSlide.length != 0 ) {
						location.hash = $nextSlide.data('name');
						renderLightbox($nextSlide);
					}
				}
			});
		});

		$prev.click(function() {
			var $currentSlide = $lightbox.attr('data-index');
			
			$galleryItems.each(function() {
				if( $(this).is(':visible') && $(this).attr('data-id') == $currentSlide ) {
					var $prevSlide = $(this).prevAll('div:visible');
					if( $prevSlide.length != 0 ) {
						location.hash = $prevSlide.data('name');
						renderLightbox($prevSlide);
					}
				}
			});
		});
}

export { gallery };